import React, { useEffect, useMemo, useState } from 'react';
import "./UserMenu.css";
import { BACKEND_URL } from '../../services/Helper';
import { toast } from "react-toastify";
import { useNavigate, useOutletContext } from "react-router-dom";
import { sortOffersByDistance } from "../../utils/geoUtils"
import secimage from "../../Assets/hero.jpg"
import AOS from "aos";
import "aos/dist/aos.css";

const notifyA = (msg) => toast.error(msg);

const UserMenu = () => {
    const navigate = useNavigate();
    const { location } = useOutletContext(); // user's location from parent
    const [userallmenu, setUserallmenu] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        let mounted = true;
        const fetchAllMenu = async () => {
            setLoading(true);
            setError("");
            try {
                const res = await fetch(`${BACKEND_URL}/nearbe/getallMenu`, {
                    method: "GET",
                });
                if (!res.ok) throw new Error("Failed to fetch offers");

                const data = await res.json();
                console.log(data);

                const menus = data.allMenu || [];
                if (mounted) setUserallmenu(menus);
            } catch (err) {
                if (mounted) {
                    setError("Something went wrong! Please try after some time");
                    notifyA("Something went wrong! Please try after some time");
                }
            } finally {
                if (mounted) setLoading(false);
            }
        };

        fetchAllMenu();

        return () => { mounted = false; };
    }, []); // run once on mount

    // derive displayedMenus from userallmenu + location without mutating state
    const displayedMenus = useMemo(() => {
        // First: base sort by distance (ascending) so groups are correct
        const menus = sortOffersByDistance(userallmenu, location).slice();

        // Now group into 2 km rings and sort each ring by offer %
        menus.sort((a, b) => {
            // distance group index: 0–2 km = 0, 2–4 km = 1, etc.
            const groupA = Math.floor((a.distance || 0) / 2);
            const groupB = Math.floor((b.distance || 0) / 2);

            if (groupA !== groupB) {
                // If not in same 2 km group → lower group (nearer) first
                return groupA - groupB;
            }

            // Same group: higher offerPercentage first
            const offerA = a.offerPercentage ?? 0;
            const offerB = b.offerPercentage ?? 0;
            if (offerA !== offerB) return offerB - offerA;

            // If same offer, finally sort by actual distance
            return (a.distance || 0) - (b.distance || 0);
        });

        return menus;
    }, [userallmenu, location]);


    // Google Maps direction URL
    const getGoogleMapsUrl = (restLat, restLon) => {
        if (location) {
            return `https://www.google.com/maps/dir/?api=1&origin=${location.lat},${location.lon}&destination=${restLat},${restLon}`;
        } else {
            return `https://www.google.com/maps/dir/?api=1&destination=${restLat},${restLon}`;
        }
    };

    useEffect(() => {
        AOS.init({ duration: 1200 });
    }, []);

    if (loading) return <p className="no-offer-msg">⏳ Loading Menu...</p>;
    if (error) return <p className="no-offer-msg">⚠️ {error}</p>;

    return (
        <div className='usermenu-item' data-aos="fade-up">
            <input
                type="text"
                placeholder="Search menu..."
                className="offer-search-input"
                onChange={(e) => setSearchTerm(e.target.value)}
            />
            {displayedMenus.length === 0 ? (
                <p className="no-offer-msg">🚫 No menu present</p>
            ) : (
                displayedMenus
                    .filter((allmenu) =>
                        allmenu?.itemName?.toLowerCase().includes(searchTerm.toLowerCase())
                    )
                    .map((allmenu) => (
                        <div key={allmenu._id} className='usermenucard' >
                            <div className='menucard-image'>
                                <img
                                    src={allmenu?.itemImage || secimage}
                                    alt={allmenu?.itemName ? `${allmenu.itemName} image` : 'menu image'}
                                />
                            </div>

                            <div className='usercard-content'>
                                <h3 className='hotelname'
                                    onClick={() =>
                                        navigate("/userdashboard/restaurants/info", {
                                            state: { hotels: allmenu.postedBy }
                                        })
                                    }
                                >
                                    {allmenu?.postedBy?.shopName || 'Unknown Shop'}
                                </h3>

                                <h3>
                                    {allmenu?.itemName}{" "}
                                    {allmenu?.offerPercentage && (
                                        <span className="userofferper">
                                            {allmenu.offerPercentage}% OFF
                                        </span>
                                    )}
                                </h3>

                                <p className='useritem-quantity'>
                                    {allmenu?.itemdescription}
                                </p>

                                <div className='userprice-statu'>
                                    <span className='userprice'>
                                        Rs-{allmenu?.itemPrice}
                                    </span>
                                    <span className='usermenustatus-avalibility'>
                                        {allmenu?.availability}
                                    </span>
                                </div>

                                <div className='userextra-info'>
                                    Preparation Time : <span>⏱ {allmenu?.prepTime} mins</span>
                                </div>

                                {allmenu.distance !== null && allmenu.distance !== undefined && (
                                    <p className="offer-distance">
                                        📍 {allmenu.distance.toFixed(1)} km away
                                    </p>
                                )}

                                {location &&
                                    Number.isFinite(Number(allmenu?.postedBy?.latitude)) &&
                                    Number.isFinite(Number(allmenu?.postedBy?.longitude)) && (
                                        <a
                                            href={getGoogleMapsUrl(
                                                allmenu.postedBy.latitude,
                                                allmenu.postedBy.longitude
                                            )}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="menumaps-link"
                                        >
                                            🗺️  <span>Watch on</span> Google Maps
                                        </a>
                                    )}
                            </div>
                        </div>
                    ))
            )}
        </div>
    );
};

export default UserMenu;
